module.exports = __webpack_public_path__ + "static/feature_img3-aee48591337e319c7a31ae7b011fffea.jpg";